import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { Menu, X } from 'lucide-react';
import logo from '../assets/images/logo-navbar.png';
import LanguagePicker from '../components/LanguagePicker';

const HeaderWrapper = styled.header`
  background: transparent;
  padding-left: 2rem;
  padding-right: 4rem;
  padding-top: 0rem;
  padding-bottom: 0rem;
  @media (max-width: 768px) {
    padding-left: 1rem;
    padding-right: 1rem;
  }
`;

const Nav = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Logo = styled(Link)`
  height: 75px;
  margin-left: 10px;
  
  @media (max-width: 768px) {
    height: 60px;
    margin-left: 0;
  }
`;

const LogoImage = styled.img`
  height: 100%;
  object-fit: contain;
`;

const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;
`;

const NavLinks = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;

  @media (max-width: 768px) {
    display: none;
  }
`;

const MobileMenu = styled.div`
  display: none;
  position: absolute;
  top: 90px;
  left: 0;
  right: 0;
  background: #90C4D9;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
  z-index: 10000;
  gap: 1rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  
  &.open {
    display: flex;
  }
`;

const Divider = styled.div`
  width: 90%;
  border-top: 1px solid white;
  margin: 0.5rem 0;
`;

const NavItem = styled.span`
  color: white;
  text-decoration: none;
  font-weight: bold;
  font-size: 1.2rem;
  position: relative;
  
  a {
    color: white;
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }

  &::after {
    content: '.';
    color: #47ABDB;
    margin-left: 2px;
  }
`;

const LanguagePickerWrapper = styled.div`
  margin-left: 2rem;
  
  @media (max-width: 768px) {
    margin-left: 0;
  }
`;

const MobileMenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  
  @media (max-width: 768px) {
    display: block;
    margin-left: 1rem;
  }
`;

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const ExternalLink = ({ to, children }) => {
    return (
      <NavItem>
        <a href={to} target="_blank" rel="noopener noreferrer">{children}</a>
      </NavItem>
    );
  };
  
  return (
    <HeaderWrapper>
      <Nav>
        <Logo to="/">
          <LogoImage src={logo} alt="HEARTS Logo" />
        </Logo>
        
        <RightSection>
          <NavLinks>
            <ExternalLink to="https://public.heartport.org">HeartPort Public</ExternalLink>
            <ExternalLink to="https://expert.heartport.org">HeartPort Expert</ExternalLink>
            <ExternalLink to="https://public.heartport.org/crew">Crew</ExternalLink>
          </NavLinks>
          
          <LanguagePickerWrapper>
            <LanguagePicker />
          </LanguagePickerWrapper>
          
          <MobileMenuButton onClick={() => setIsMenuOpen(!isMenuOpen)}>
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </MobileMenuButton>
        </RightSection>
      </Nav>
      
      <MobileMenu className={isMenuOpen ? 'open' : ''}>
        <ExternalLink to="https://public.heartport.org">HeartPort Public</ExternalLink>
        <ExternalLink to="https://expert.heartport.org">HeartPort Expert</ExternalLink>
        <ExternalLink to="https://public.heartport.org/crew">Crew</ExternalLink>
        <Divider />
      </MobileMenu>
    </HeaderWrapper>
  );
};

export default Header;